import { defineStore } from 'pinia'
import { computed, ref } from 'vue'

import { defaultRegion, regions } from '../constants/regions'

export const useRegionStore = defineStore('region', () => {
  // Region switching is disabled; always use the default region (China in prod, test otherwise).
  const currentRegionKey = ref(defaultRegion.envKey)

  const currentRegion = computed(() => defaultRegion)

  return {
    currentRegion,
    currentRegionKey,
    regions,
  }
})
